export const solarPanelStatuses = {
  online: 'online',
  subOptimal: 'sub_optimal',
  optimal: 'optimal',
  offline: 'offline',
}
